<script>
    import {getStyleValue} from '../../Common/tools';
    import {initResizable} from "../global";
    import {onMount} from "svelte";
    import {External} from "../../external";

    export let data, globalStyle, onChange, onFocus;
    let top;

    onMount(function () {
        let jqTop = External.$(top);

        let resizeTop = function (event, ui) {
            if (ui.size.height < 0) {
                ui.size.height = 0;
            }
            data.style = Object.assign({}, data.style, {height: ui.size.height + "px"});
        };

        initResizable(jqTop, resizeTop, null, null, () => onChange('padding'), onFocus);
    });
</script>
<tr>
    <th class="column column-st" width="{getStyleValue(globalStyle.width, 600)}" align="center">
        <table class="row" align="center" bgcolor="{data.style.backgroundColor}" cellpadding="0" cellspacing="0">
            <tbody>
            <tr>
                <td class="spacer" height="{getStyleValue(data.style.height, 80)}" colspan="2"
                    style="font-size: {data.style.height}; line-height: {data.style.height};">
                    <div class="spacer-top" bind:this={top}
                         style="bottom:0;position:absolute;width:100%;height:{data.style.height || '80px'}">
                        &nbsp;
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </th>
</tr>